import { Component, Input, OnChanges } from '@angular/core';
import { CellUtil, ComponentData, TabData, TabUtil } from '@ddt-web/data-service';
import * as get from 'lodash/get';
import * as isNil from 'lodash/isNil';

import { PerformanceUtil } from '../utils/performance.util';

@Component({
	selector: 'perf-performance-overview',
	templateUrl: './performance-overview.component.html',
	styleUrls: ['./performance-overview.component.scss']
})
export class PerformanceOverviewComponent implements OnChanges {
	@Input() public data: ComponentData;
	@Input() public isFirstComponentOnPage: boolean = true;
	@Input() public customAdvisoryFee: number;
	@Input() public isDisclosureExpandable: boolean = true;
	@Input() public showSimplifiedDisclaimer: boolean = false;
	@Input() public isCustomFeeEnabled: boolean = false;

	public hasBlkModel: boolean;
	public hasCustomModel: boolean;
	public isHypoPerformanceValidData: boolean;
	public isHypoNetCustomPerformanceValidData: boolean;
	public cellUtils: CellUtil;
	public asOfDate: string;

	public shouldShowHypotheticalPerformance: boolean = false;

	public tabs: TabData[];
	public tableComponentData: ComponentData;
	public hypoGrossPerfTableTabData: TabData;
	public hypoNetCustomPerfTableTabData: TabData;

	public columnWidths: number[];

	public validTableComponentDataIds = ['hypo-performance'];

	public ngOnChanges(): void {
		if (this.data.success) {
			// asOfDate is used for both gross and net hypothetical performance
			this.asOfDate = get(this.data.getTabById('hypo-perf-as-of-date'), 'tableData[0].cells[0][0].formattedValue');

			this.validTableComponentDataIds = [];
			const hypoGrossTab: TabData = this.data.getTabById('hypo-performance');
			this.validTableComponentDataIds.push(hypoGrossTab?.config?.id);

			this.hypoGrossPerfTableTabData = TabUtil.getVisibleTabData(hypoGrossTab);
			this.isHypoPerformanceValidData = CellUtil.isValidCellData(this.hypoGrossPerfTableTabData);

			this.hypoNetCustomPerfTableTabData = TabUtil.getVisibleTabData(this.data.getTabById('hypo-net-custom-performance'));
			this.isHypoNetCustomPerformanceValidData = CellUtil.isValidCellData(this.hypoNetCustomPerfTableTabData);

			const hypoGrossPerfTabHasError = this.hypoGrossPerfTableTabData && !this.isHypoPerformanceValidData;
			const hypoNetCustomPerfTabHasError = this.hypoNetCustomPerfTableTabData && !this.isHypoNetCustomPerformanceValidData;

			// check if performance data is provided (either for chart or table), otherwise component will not be shown
			const hypoGrossPerfChartTabData = this.data.getTabById('hypo-chart');
			const hypoNetCustomPerfChartTabData = this.data.getTabById('hypo-custom-net-chart');

			const performanceData = this.hypoGrossPerfTableTabData || hypoGrossPerfChartTabData || hypoNetCustomPerfChartTabData;

			this.shouldShowHypotheticalPerformance = this.isCustomFeeEnabled && this.customAdvisoryFee ?
				!isNil(performanceData) && !hypoGrossPerfTabHasError && !hypoNetCustomPerfTabHasError : !isNil(performanceData) && !hypoGrossPerfTabHasError;

			if (this.shouldShowHypotheticalPerformance) {
				const showHypoNetPerformanceRow: boolean = this.isCustomFeeEnabled
					? !!(this.isHypoNetCustomPerformanceValidData && this.customAdvisoryFee)
					: this.isHypoNetCustomPerformanceValidData;
				if (showHypoNetPerformanceRow) {
					this.validTableComponentDataIds.push('hypo-net-custom-performance');
				}
				[this.tabs, this.columnWidths] = PerformanceUtil.getPortfolioPerfTableData(this.validTableComponentDataIds, this.data, this.customAdvisoryFee);
			}
		}
	}
}
